<template>
  <v-container class="slider-box maxWidthSet">
    <!-- Slider text -->
    <div id="slider-wrapper">
      <v-row id="slider" align-content="center">
        <transition-group name="card">
          <div
            role="heading"
            aria-level="1"
            class="card card-text"
            v-for="item in currentSliderItem"
            v-touch="{
              left: () => changeSlide(currentSliderIndex + 1),
              right: () => changeSlide(currentSliderIndex - 1),
            }"
            :key="item.id"
          >
            <div class="greeting font-size-mobile">
              {{ $t('L_welcome_sentence') }}
              {{ customerStore.customerProfile.firstName }}
            </div>
          </div>
        </transition-group>
      </v-row>
    </div>
  </v-container>
</template>

<script lang="ts">
import { useCustomerStore } from '@/stores/customer/customer.store';
import { mapStores } from 'pinia';
import { defineComponent } from 'vue';
import { Translations } from '@/i18n/models';

export default defineComponent({
  name: 'DashboardMessageSlider',
  data: () => ({
    Translations: Translations,
    currentSliderIndex: 0,
    sliderItems: [{ id: Math.random() }, { id: Math.random() }, { id: Math.random() }],
  }),
  computed: {
    ...mapStores(useCustomerStore),
    currentSliderItem() {
      return [this.sliderItems[this.currentSliderIndex]];
    },
  },
  methods: {
    changeSlide(index: number) {
      switch (true) {
        case index < 0:
          this.currentSliderIndex = this.sliderItems.length - 1;
          break;
        case index >= this.sliderItems.length:
          this.currentSliderIndex = 0;
          break;
        default:
          this.currentSliderIndex = index;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.maxWidthSet {
  max-width: 1024px;
  margin: auto;
}
#slider-wrapper {
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  position: relative;
  #slider {
    .card {
      width: 100%;
      height: 100%;
    }
  }
  #dots {
    width: 100%;
    text-align: center;
    .slider-circle {
      display: inline-block;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      border: solid 1px white;
      margin: 0 4px;
      cursor: pointer;
      &.active {
        background: #ffffff;
      }
    }
  }
  .card-text {
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    .greeting {
      font-weight: 600;
    }
  }
}
.card {
  transition: all 0.5s;
}
.card-enter,
.card-leave-to {
  transform: scale(0);
  opacity: 0;
}
.card-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
.card-enter-to {
  opacity: 1;
  transform: scale(1);
}
.card-leave-active {
  position: absolute;
}
.card-move {
  opacity: 1;
  transition: all 0.5s;
}
.slider-box {
  background-color: #184976;
  border-radius: 4px;
  @media only screen and (max-width: 768px) and (min-width: 600px) {
    margin-top: 24px;
  }
}
</style>
